var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gameView"}},_vm._l((_vm.currentRoomData),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"roomTitle"},[_vm._v(" "+_vm._s(item.room.title)+" ")]),_vm._l((item.room.object),function(item,roomindex){return _c('div',{key:item.id,staticClass:"objects",class:[item.taken ? 'hidden' : '', 'item'],style:({
            position: ['absolute'],
            left: item.position[0] + 'px',
            top: item.position[1] + 'px',
            width: item.position[2] + 'px',
            height: item.position[3] + 'px'
          }),on:{"click":function($event){_vm.interactWithObjectInRoom(item, roomindex)}}},[_c('img',{attrs:{"src":item.img}})])})],2)}))}
var staticRenderFns = []

export { render, staticRenderFns }